/** Ajax 详情 */
import './index.scss'
import React from 'react'
import {message, Tabs} from 'antd';
import DateTimePicker from '../../components/DateTimePicker/index'
import AjaxNature from './components/ajaxNature';
import AjaxTransfer from './components/ajaxTransfer';
import AjaxError from './components/ajaxError';
import api from "../../lib/api";

const { TabPane } = Tabs;

class AjaxErrorPage extends React.Component {
  state = {
    dateTimeVal: '24小时',
    resourcePath: '',
    methodType: '',
    startTime: '',
    endTime: '',
    echartsData: []
  };
  UNSAFE_componentWillMount = () => {
    const ajaxDetail = JSON.parse(sessionStorage.getItem('ajaxDetail'));
    if (ajaxDetail) {
      // 自定义日期 需传开始日期 结束日期
      if (ajaxDetail.dateTimeVal === '自定义') {
        this.setState({
          dateTimeVal: '自定义',
          startTime: ajaxDetail.startTime,
          endTime: ajaxDetail.endTime,
          resourcePath: ajaxDetail.url,
          methodType: ajaxDetail.methodType
        })
      } else {
        this.setState({
          dateTimeVal: ajaxDetail.dateTimeVal || '24小时',
          resourcePath: ajaxDetail.url,
          methodType: ajaxDetail.methodType
        })
      }
    }
  };
  // 日期时间控件
  handleDateTimePicker = (dateTimeVal, startTime, endTime) => {
    this.setState({
      dateTimeVal,
      startTime,
      endTime
    }, () => {
      this.ajaxNatureData();
      // 组件存在则刷新数据 日期不变 数据不变
      if (this.refs.ajaxTransfer) {
        this.refs.ajaxTransfer.ajaxTransferData();
      }
      if (this.refs.ajaxError) {
        this.refs.ajaxError.ajaxErrorData();
      }
    });
  };
  // 图表数据
  ajaxNatureData() {
    const {startTime, endTime, resourcePath, methodType} = this.state;
    const params = {
      startTime,
      endTime,
      resourcePath,
      methodType
    };
    api.ajaxNatureData(params).then(res => {
      if (res.success && res.status === 200) {
        this.setState({
          echartsData: res.data || []
        });
      } else {
        message.error(res.message);
      }
    })
  };
  render() {
    const {history} = this.props;
    const {dateTimeVal, startTime, endTime, resourcePath, methodType, echartsData} = this.state;
    return (
      <div className='ajax-detail-page'>
        <div className='ajax-detail-page-top'>
          <span className='resource-path'>{resourcePath}</span>
          <DateTimePicker comClassName='float-r' value={dateTimeVal} startTime={startTime} endTime={endTime} handleDateTimePicker={this.handleDateTimePicker} />
        </div>
        <Tabs defaultActiveKey="ajaxNature">
          <TabPane tab="Ajax性能" key="ajaxNature">
            <AjaxNature echartsData={echartsData} />
          </TabPane>
          <TabPane tab="调用页面" key="ajaxTransfer">
            <AjaxTransfer ref='ajaxTransfer' filterData={{startTime, endTime, resourcePath, methodType}} />
          </TabPane>
          <TabPane tab="异常调用查询" key="ajaxError">
            <AjaxError history={history} ref='ajaxError' filterData={{dateTimeVal, startTime, endTime, resourcePath, methodType}} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default AjaxErrorPage
